import { showHeaderOverlay, hideHeaderOverlay } from 'Functions/overlay'
import { checkResolution } from 'Functions/helpers'
import 'Ui/tabs'
import 'Components/navigation-menu-aim'

const aside = {
    trigger: document.querySelector('.js-aside-trigger'),
    target: document.querySelector('.js-header-navigation'),
    toggle() {
        if (this.trigger.classList.contains('is-active')) {
            this.close()
        } else {
            this.open()
        }
    },
    open() {
        this.trigger.classList.add('is-active')
        this.target.classList.add('is-active')
        showHeaderOverlay('nav-aside')
        document.addEventListener('click', this.handleClickOutside.bind(this))
    },
    close() {
        this.trigger.classList.remove('is-active')
        this.target.classList.remove('is-active')
        hideHeaderOverlay('nav-aside')
        document.removeEventListener('click', this.handleClickOutside.bind(this))
    },
    handleClickOutside(event) {
        if (!checkResolution('lg') && !this.target.contains(event.target) && !this.trigger.contains(event.target)) {
            this.close()
        }
    }
}

if (aside.trigger) {
    aside.trigger.addEventListener('click', event => {
        aside.toggle()
    })
}